module.exports = __webpack_public_path__ + "static/media/xcodeIllustration.b8746427.jpg";